import {
    ACTIVE_CONTROLLER
} from '../constants'
import store from '../store'

export const setTimelineControllers= controlState => store.dispatch({ type: ACTIVE_CONTROLLER, controlState })
